import { render, staticRenderFns } from "./InfoCollapse.vue?vue&type=template&id=8386094e&scoped=true&"
import script from "./InfoCollapse.vue?vue&type=script&lang=js&"
export * from "./InfoCollapse.vue?vue&type=script&lang=js&"
import style0 from "./InfoCollapse.vue?vue&type=style&index=0&id=8386094e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8386094e",
  null
  
)

export default component.exports